<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-6 col-sm-8">
        <div class="card">
          <div class="card-body">
            <h5>{{ $t("setting.change-password") }}</h5>
            <div>
              <b-alert v-if="isFail" show dismissible variant="danger">{{
                $t("form.error.current-pass")
              }}</b-alert>
              <table class="table text-left">
                <thead>
                  <tr>
                    <td width="30%">
                      <b>{{ $t("user-management.current_password") }}</b>
                    </td>
                    <td width="70%">
                      <div class="input-group">
                        <input
                          :type="show.curr ? 'text' : 'password'"
                          class="form-control"
                          placeholder="*******"
                          v-model="form.current_password"
                          :class="{
                            'is-invalid':
                              submitted && $v.form.current_password.$error,
                          }"
                        />
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <div v-if="show.curr">
                              <i
                                @click="show.curr = false"
                                class="fas fa-eye-slash"
                              ></i>
                            </div>
                            <div v-else>
                              <i
                                @click="show.curr = true"
                                class="fas fa-eye"
                              ></i>
                            </div>
                          </span>
                        </div>
                        <div
                          v-if="submitted && $v.form.current_password.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.form.current_password.required">{{
                            $t("form.error.text")
                          }}</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="30%">
                      <b>{{ $t("user-management.new_password") }}</b>
                    </td>
                    <td width="70%">
                      <div class="input-group">
                        <input
                          :type="show.new ? 'text' : 'password'"
                          class="form-control"
                          placeholder="*******"
                          v-model="form.new_password"
                          :class="{
                            'is-invalid':
                              submitted && $v.form.new_password.$error,
                          }"
                        />
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <div v-if="show.new">
                              <i
                                @click="show.new = false"
                                class="fas fa-eye-slash"
                              ></i>
                            </div>
                            <div v-else>
                              <i
                                @click="show.new = true"
                                class="fas fa-eye"
                              ></i>
                            </div>
                          </span>
                        </div>
                        <div
                          v-if="submitted && $v.form.new_password.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.form.new_password.required">{{
                            $t("form.error.text")
                          }}</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="30%">
                      <b>{{ $t("user-management.confirm_password") }} </b>
                    </td>
                    <td width="70%">
                      <div class="input-group">
                        <input
                          :type="show.conf ? 'text' : 'password'"
                          class="form-control"
                          placeholder="*******"
                          v-model="form.confirm_password"
                          :class="{
                            'is-invalid':
                              submitted && $v.form.confirm_password.$error,
                          }"
                        />
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <div v-if="show.conf">
                              <i
                                @click="show.conf = false"
                                class="fas fa-eye-slash"
                              ></i>
                            </div>
                            <div v-else>
                              <i
                                @click="show.conf = true"
                                class="fas fa-eye"
                              ></i>
                            </div>
                          </span>
                        </div>
                        <div
                          v-if="submitted && $v.form.confirm_password.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.form.confirm_password.required">{{
                            $t("form.error.text")
                          }}</span>
                          <span
                            v-if="
                              $v.form.confirm_password.required &&
                              !$v.form.confirm_password.sameAsPassword
                            "
                            >{{ $t("form.error.match-pass") }}</span
                          >
                        </div>
                      </div>
                    </td>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="text-right mr-2">
              <router-link to="/profile" class="mr-1">
                <b-button class="btn" variant="danger">
                  {{ $t("button.cancel") }}
                </b-button>
              </router-link>
              <b-button
                class="btn"
                variant="success"
                @click="updatePassword"
                type="button"
              >
                <b-spinner v-if="loading" label="Loading ..." small></b-spinner>
                <span v-if="!loading" class="d-none d-sm-inline-block">
                  {{ $t("button.update") }}
                </span>
                <span v-if="loading"> Loading.. </span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/user.service";
import appConfig from "@/app.config";
import moment from "moment";
import Stat from "@/components/widgets/stat";
import { required, sameAs } from "vuelidate/lib/validators";
import Vue from "vue";
import { userService } from "@/helpers/authservice/user.service";

export default {
  page: {
    title: "Change Password",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Stat },
  data() {
    return {
      refresh_token: 0,
      urlImage: process.env.VUE_APP_BASE_API_URL_AVATAR,
      title: this.$t("setting.change-password"),
      isFail: false,
      show: {
        curr: false,
        new: false,
        conf: false,
      },
      form: {
        current_password: "",
        new_password: "",
        confirm_password: "",
      },
      submitted: false,
      loading: false,
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Profile",
          href: "/profile",
        },
        {
          text: this.$t("setting.change-password"),
          active: true,
        },
      ],
    };
  },
  validations: {
    form: {
      current_password: { required },
      new_password: { required },
      confirm_password: { required, sameAsPassword: sameAs("new_password") },
    },
  },

  methods: {
    updatePassword() {
      let ferr = 0;
      this.submitted = true;
      // console.log('sub', this.submitted);
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        UserService.changePassword(this.form)
          .then((response) => {
            if (response.status == 201) {
              let new_token = response.data.refresh_access_token;
              userService.splitToken(new_token);
              this.updatedProfile();
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              ferr = 2;
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });

              this.$v.$reset();
              this.resetInput();
              this.$router.push("/profile");
              this.loading = false;
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.updatePassword();
            } else {
              console.log("err", err.response);
              if (err.response.status == 401) {
                userService.logout();
              } else {
                this.isFail = true;
                console.log(err);
                this.loading = false;
              }
            }
          });
      }
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
    resetInput() {
      this.form.current_password = "";
      this.form.new_password = "";
      this.form.confirm_password = "";
    },
  },
};
</script>      